import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, of } from 'rxjs';
import { RestService } from './rest.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  isSaveChangesEnabled: boolean = false;
  isProfile = new Subject();
  private appSteps: Subject<string> = new Subject();
  private notification = new Subject();
  sharedNotification = this.notification.asObservable();
  private invites = new Subject();
  sharedInvites = this.invites.asObservable();
  public filters = new Subject();
  public txnFilters = new Subject();
  transactionFilter = this.filters.asObservable();
  txnFilterType = this.txnFilters.asObservable();

  constructor(private restService: RestService) { }

  isValidEmail(email) {
    // tslint:disable-next-line:max-line-length
    const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return emailRegex.test(email);
  }

  isPasswordStrong(password: string) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // tslint:disable-next-line:max-line-length
        const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{7,20}$/;
        const isValid = passwordRegex.test(password);
        if (isValid) {
          resolve(true);
        } else {
          resolve(false);
        }
      }, 100);
    });
  }

  searchWholesaleAgencies(term?: string, defaultData: any[] = []) {
    if (term) {
      return this.restService
        .fetch(`/api/agents/wholesale/search?term=${term}`)
        .pipe(map(agencies => agencies));
    } else {
      return of(defaultData);
    }
  }

  searchAgents(term?: string, defaultData: any[] = []) {
    if (term) {
      return this.restService
        .fetch(`/api/agents/self/search?term=${term}`)
        .pipe(map(agents => agents));
    } else {
      return of(defaultData);
    }
  }

  searchUsers(term?: string, defaultData: any[] = []) {
    if (term) {
      return this.restService
        .fetch(`/api/users/self/search?term=${term}`)
        .pipe(map(users => users));

    } else {
      return of(defaultData);
    }
  }

  searchProducts(term?: string, defaultData: any[] = []) {
    if (term) {
      return this.restService
        .fetch(`/api/products/search/by?term=${term}`)
        .pipe(map(products => products));
    } else {
      return of(defaultData);
    }
  }

  getStatusClass(status: string) {
    let className: string;
    const statusMapper: any = {
      Pending: () => {
        className = 'text-info badge badge-light text-uppercase';
      },
      Approved: () => {
        className = 'text-uppercase badge badge-light text-success';
      },
      Rejected: () => {
        className = 'text-danger badge badge-light text-uppercase';
      },
      Canceled: () => {
        className = 'text-danger badge badge-light text-uppercase';
      },
      Failed: () => {
        className = 'text-danger badge badge-light text-uppercase';
      },
      Settled: () => {
        className = 'text-success badge badge-light text-uppercase';
      },
      Success: () => {
        className = 'text-success badge badge-light text-uppercase';
      },
      Completed: () => {
        className = 'text-success badge badge-light text-uppercase';
      },
      Submitted: () => {
        className = 'text-warning badge badge-light text-uppercase';
      },
      InProgress: () => {
        className = 'text-info badge badge-light text-uppercase';
      },
      ToDo: () => {
        className = 'text-secondary badge badge-light text-uppercase';
      },
      InClarification: () => {
        className = 'text-warning badge badge-light text-uppercase';
      },
      Invited: () => {
        className = 'text-info badge badge-light text-uppercase';
      },
      Active: () => {
        className = 'text-uppercase badge badge-light text-success';
      },
      InActive: () => {
        className = 'text-danger badge badge-light text-uppercase';
      },
      Archived: () => {
        className = 'text-danger badge badge-light text-uppercase';
      },
      default: () => {
        // 
      },
    };
    status in statusMapper ? statusMapper[status]() : statusMapper.default();
    return className;
  }

  /**
   * get notifications for user
   */
  getNotifications(pageNo: number = 1, limit: number = 20) {
    return this.restService.fetch(`/api/notifications?pageNo=${pageNo}&limit=${limit}`);
  }

  setNotifications(data: any) {
    this.notification.next(data);
  }

  setInvites(data: any) {
    this.invites.next(data);
  }

  setFilter(data: any, txnFilters?: any) {
    this.filters.next(data);
    console.log('txnFilters:-->> ', txnFilters);
    if (txnFilters) {
      this.txnFilters.next(txnFilters);
    }
  }

  loadScript(url: string) {
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  loadInvites() {
    this.restService.fetch(`/api/agent-invites`).subscribe(innerInvites => {
      this.invites.next(innerInvites);
    });
  }
}
